import { HttpClient, HttpMethods } from "../types/httpClient";

function sendActivityReport(httpClient: HttpClient) {
  return () =>
    httpClient.sendHttpRequest<void>({
      endpoint: "/resources/generate-report-activity",
      method: HttpMethods.POST,
    });
}

export { sendActivityReport };
